import React from "react";

const PageLoading = () => {
  return (
    <div
      style={{
        position: "absolute",
        right: "150px",
        left: "0",
        top: "50%",
        margin: "0 auto",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        style={{
          margin: "auto",
          background: "rgb(241, 242, 243)",
          display: "block",
          shapeRendering: "auto",
        }}
        width="200px"
        height="200px"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
      >
        <circle cx="80" cy="50" r="5" fill="#ff3d00">
          <animate
            attributeName="cx"
            values="80;50"
            keyTimes="0;1"
            dur="1s"
            repeatCount="indefinite"
          ></animate>
          <animate
            attributeName="cy"
            values="50;80"
            keyTimes="0;1"
            dur="1s"
            repeatCount="indefinite"
          ></animate>
          <animate
            attributeName="fill"
            values="#ff3d00;#ff3d00"
            keyTimes="0;1"
            dur="1s"
            repeatCount="indefinite"
          ></animate>
        </circle>
        <circle cx="50" cy="80" r="5" fill="#ff3d00">
          <animate
            attributeName="cx"
            values="50;20"
            keyTimes="0;1"
            dur="1s"
            repeatCount="indefinite"
          ></animate>
          <animate
            attributeName="cy"
            values="80;50.00000000000001"
            keyTimes="0;1"
            dur="1s"
            repeatCount="indefinite"
          ></animate>
          <animate
            attributeName="fill"
            values="#ff3d00;#ff3d00"
            keyTimes="0;1"
            dur="1s"
            repeatCount="indefinite"
          ></animate>
        </circle>
        <circle cx="20" cy="50.00000000000001" r="5" fill="#ff3d00">
          <animate
            attributeName="cx"
            values="20;49.99999999999999"
            keyTimes="0;1"
            dur="1s"
            repeatCount="indefinite"
          ></animate>
          <animate
            attributeName="cy"
            values="50.00000000000001;20"
            keyTimes="0;1"
            dur="1s"
            repeatCount="indefinite"
          ></animate>
          <animate
            attributeName="fill"
            values="#ff3d00;#ff3d00"
            keyTimes="0;1"
            dur="1s"
            repeatCount="indefinite"
          ></animate>
        </circle>
        <circle cx="49.99999999999999" cy="20" r="5" fill="#ff3d00">
          <animate
            attributeName="cx"
            values="49.99999999999999;80"
            keyTimes="0;1"
            dur="1s"
            repeatCount="indefinite"
          ></animate>
          <animate
            attributeName="cy"
            values="20;49.99999999999999"
            keyTimes="0;1"
            dur="1s"
            repeatCount="indefinite"
          ></animate>
          <animate
            attributeName="fill"
            values="#ff3d00;#ff3d00"
            keyTimes="0;1"
            dur="1s"
            repeatCount="indefinite"
          ></animate>
        </circle>
      </svg>
    </div>
  );
};
export default PageLoading;
